<div class="child-inventory-form" style="height:auto">
  <header class="source-inventory" aria-label="Original inventory">
    <span>Original coffee</span>
    <strong>{{ InventoryItem.InventoryTypeName || 'Coffee reference' }}</strong>
    <small>Ref #{{ InventoryItem.InventoryID }} · {{ InventoryItem.AvailableQty | number }} bags available</small>
  </header>
  <form #slackForm="ngForm" class="form-flow" style="height:auto">
    <app-inventory-website-visibility [(invisible)]="WebInvisible"></app-inventory-website-visibility>

    <fieldset class="rms-fieldset">
      <legend>Inventory Data</legend>

      <div class="fields">
        <rms-input type="decimal"
                   name="NetWeight"
                   label="Net Weight"
                   [ngModel]="InventoryItem.NetWeight"
                   [disabled]="true">
        </rms-input>

        <rms-input type="decimal"
                   name="AvailableWeight"
                   label="Available Weight"
                   [ngModel]="availableWeight"
                   [disabled]="true">
        </rms-input>
      </div>
    </fieldset>

    <fieldset class="rms-fieldset" style="display:flex; flex-direction:column">
      <legend>Slack Configuration</legend>

      <div style="display:flex; justify-content:space-between; align-items:center">
        <div style="width:20vw">
          <rms-input type="decimal"
                     name="TotalSlackWeight"
                     label="Total Weight to Slack (lbs)"
                     [required]="true"
                     [(ngModel)]="TotalSlackWeight">
          </rms-input>
        </div>
        <div style="width:20vw">
          <rms-number name="BagsAffected"
                      label="Bags Affected"
                      [required]="true"
                      [(ngModel)]="BagsAffected">
          </rms-number>
        </div>
        <!--<rms-checkbox label="Manual Weight"
                      [(ngModel)]="ManualWeight" name="ManualWeight">
        </rms-checkbox>-->
      </div>
      @if(ManualWeight){
      <div class="weight-range">
        <rms-data-slider name="MinBagWeight"
                         label="Minimum Bag Weight"
                         [min]="1"
                         [max]="MaxBagWeight"
                         [step]=".01"
                         [(ngModel)]="MinBagWeight">
        </rms-data-slider>

        <rms-data-slider name="MaxBagWeight"
                         label="Maximum Bag Weight"
                         [min]="MinBagWeight"
                         [max]="200"
                         [step]=".01"
                         [(ngModel)]="MaxBagWeight">
        </rms-data-slider>
      </div>
      }
    </fieldset>

    @if (allocation) {
    <fieldset class="rms-fieldset allocation-preview">
      <legend>Inventory Allocation</legend>

      <div class="allocation-row">
        <span>Allocation Mode</span>
        <strong>
          {{ allocation.mode === 'automatic' ? 'Automatic' : 'Manual Weight' }}
        </strong>
      </div>

      <div class="allocation-row">
        <span>Full Bags</span>
        <strong>{{ allocation.fullBags }}</strong>
      </div>

      <div class="allocation-row">
        <span>Weight Per Full Bag</span>
        <strong>
          {{ allocation.weightPerBag | number:'1.0-2' }} lbs
        </strong>
      </div>

      <div class="allocation-row">
        <span>Full Bag Weight</span>
        <strong>
          {{ allocation.allocatedWeight | number:'1.0-2' }} lbs
        </strong>
      </div>

      @if (allocation.leftoverWeight > 0) {
      <div class="allocation-row leftover">
        <span>Remaining Slack</span>
        <strong>
          {{ allocation.leftoverWeight | number:'1.0-2' }} lbs
        </strong>
      </div>

      <div class="slack-message sm-font">
        1 slack bag will be created with
        {{ allocation.leftoverWeight | number:'1.0-2' }} lbs.
        It appears as a Slack child under original reference #{{ InventoryItem.InventoryID }} on the purchase order. Full bags stay on the original reference.
      </div>
      }
      @if (BagsAffected) {
      <div class="allocation-row">
        <span>Bags Affected</span>
        <strong>{{ BagsAffected }}</strong>
      </div>
      }

      <div class="allocation-row">
        <span>Resulting Full Bags</span>
        <strong>{{ allocation.fullBags }}</strong>
      </div>

      @if (allocation.leftoverWeight > 0) {
      <div class="allocation-row">
        <span>Slack Bags</span>
        <strong>1</strong>
      </div>
      }

      @if (slackAdjustment > 0) {
      <div class="allocation-row adjustment">
        <span>Slack Adjustment</span>
        <strong>-{{ slackAdjustment }} bag(s)</strong>
      </div>
      }
      @if (allocation.leftoverWeight === 0) {
        <p class="process-note">No extra slack bag is needed. Full bags stay on original reference #{{ InventoryItem.InventoryID }}.</p>
      }
    </fieldset>
    }
    @if (validationMessage || errorMessage) {
    <div class="sm-font text-red">
      {{ validationMessage || errorMessage }}
    </div>
    }

  </form>

  <div class="button-container">
    <button mat-button
            class="btn-bg-green"
            [disabled]="!slackForm.valid || !canSave"
            (click)="save()">
      Save
    </button>

    <button mat-button
            class="btn-bg-red"
            (click)="cancel()">
      Cancel
    </button>
  </div>
</div>
